import api from "@/lib/axios";

export interface PaymentMetrics {
  availablePayout: number;
  thisMonthEarnings: number;
  lifetimeEarnings: number;
}

export enum PaymentKeys {
  GET_METRICS = "payment-metrics",
}

// Fetch payment metrics for the authenticated expert
export const getPaymentMetrics = async (): Promise<PaymentMetrics> => {
  const response = await api.get<PaymentMetrics>("/payments/metrics");
  return response.data;
};
